type Page = {
  name: string;
  path: RegExp;
};

// WithHandlerで該当するpathに対してNginxにリダイレクトさせる
// フロー: リリース前のページpathをここに定義する -> Next.jsでの開発が終わったらページpathをここから外す -> Nginxの設定を変更する
export const UnReleasedPages: Page[] = [];

export const isReleasedInActiveStatus = (): boolean => {
  return true;
};

export const isReleasedRedesignRecruitment = (): boolean => {
  return true;
};

export const isReleasedRedesignTop = (): boolean => {
  return false;
};
